<template>
    <v-tooltip bottom class="mx-1">
        <template v-slot:activator="{ on, attrs }">
            <v-btn
                @click="$emit('click')"
                icon
                v-bind="{...attrs, ...$props}"
                v-on="on">
                <v-icon :small="small" :disabled="disabled">
                    {{icon}}
                </v-icon>
            </v-btn>
        </template>
        <span v-if="tooltip">{{tooltip}}</span>
    </v-tooltip>
</template>

<script>
export default {
    name: "PIconBtn",
    props: {
        icon: {
            required: true
        },
        tooltip: String,
        color: {
            type: String,
        },
        small: Boolean,
        disabled: Boolean,
        loading: Boolean
    }
}
</script>
